import PropTypes from "prop-types";
import React, { Component } from 'react';
import moment from "moment";
import {
  TourBtn,
  TourContainer,
  TourButtonsContainer,
  TourTextContainer,
  Img,
  HeadingComponent,
  TextContent,
  DisplayFlexContainer,
  TourButtons,
  FixedWidth,
  TourContainerWrapper,
  EmptyProductTourContainer
} from "./style";
import { Row, Col } from "antd";
import WalkThroughComponent from "../../../../Epics/AccountSummary/Pages/Component/carousel/Carousel";
import { withRouter } from "react-router-dom";
import tourBtn from "../../../../assets/icons/tour_btn.svg";
import tourBackground from "../../../../assets/icons/tour_background.svg";
import { connect } from "react-redux";
import {
  getAccountData, isGeminiUser
} from "../../../../utils/sessionUtil";
import { getpwUrl, recordError } from "../../../../utils/commonUtil";
import TooltipComponentGemini from "../../../Info/Tooltip/TooltipComponentGemini";
import SecondaryNavigationByCSR from '../../../../CSR/SecondaryNavigation/SecondaryNavigationByCSR';
import CSRSpecificDetails from '../../../../CSR/CSRSpecificDetails/CSRSpecificDetails';
import { selectAccountID, sessionLoading } from "../../../../selectors/globalSelectors";
import { productTourDerivedStates } from "../../../Header/selectors";

class ProductTour extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      isOpenTour: false,
      isOpenHeader: false,
      isTourOpen: false,
      counter: 0
    };
    this.tourContainerRef = React.createRef();
    this.toggle = this.toggle.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.isOpen !== nextProps.isOpen) {
      this.setState(
        { isOpen: nextProps.isOpen },
        this.tourBlockHeightAdjustment
      );
    }
  }

  toggle() {
    this.setState({
      isOpenTour: !this.state.isOpenTour
    });
  }

  toggleHeader = () => {
    this.setState({
      isOpenHeader: !this.state.isOpenHeader
    });
  };

  tourBlockHeightAdjustment = () => {
    this.props.tourHeightChanged(0);
  };
  tourBlockHeightAdjustmentClose = () => {
    this.props.tourHeightChanged(0);
  };

  openDrawer = (e) => {
    try {
      e.stopPropagation();
      if (this.state.isOpen) {
        this.tourBlockHeightAdjustment()
      }
      else {
        this.tourBlockHeightAdjustmentClose()
      }
      this.setState(
        {
          isOpen: !this.state.isOpen
        });
    } catch (error) {
      recordError(error);
    }
  };

  closeTour = () => {
    try {
      document.body.style.overflow = "";
      this.setState({
        isTourOpen: false
      });
    } catch (error) {
      recordError(error);
    }
  };

  openTour = () => {
    try {
      document.body.style.overflow = "hidden";
      this.setState({
        isTourOpen: true
      });
    } catch (error) {
      recordError(error);
    }
  };
  openWelcomeKit = () => {
    try {
      window.open("/sites/default/files/2019-12/WelcomeKit.pdf", "_blank");
    } catch (error) {
      recordError(error);
    }
  };

  disableWalkThrough = event => {
    try {
      if (event.target.className.indexOf('product-tour-window') !== -1) {
        this.setState({ isTourOpen: false });
      }
    } catch (error) {
      recordError(error);
    }
  };

  walkThrough = () => {
    return (
      <div data-test="walkthroughmain">
        {this.state.isTourOpen === true ? (
          <div
            data-test="walkthrough"
            className='overlay-positon overlay-background product-tour-window'
            onClick={e => this.disableWalkThrough(e)}
          >
            <Row className='overlay-container'>
              <Col>
                <WalkThroughComponent closeWalkThrough={this.closeTour} />
              </Col>
            </Row>
            <Row className='skip-overlay-container'>
              <Col>
                <p onClick={this.closeTour} id="btnSkipTour">
                  <u>SKIP TOUR</u>
                </p>
              </Col>
            </Row>
          </div>
        ) : (
            ''
          )}
      </div>
    );
  };
  handleClick = e => {
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    else {
      if (this.state.isOpen) {
        if (this.state.isOpen) {
          this.tourBlockHeightAdjustment()
        }
        else {
          this.tourBlockHeightAdjustmentClose()
        }
        this.setState(
          {
            isOpen: !this.state.isOpen
          });
      }
    }

  };

  componentWillMount() {
    document.addEventListener("mousedown", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClick, false);
  }

  showProductTour = () => {    
    const { webRegisteredDate } = this.props.accountDetails;
    return webRegisteredDate ? moment().diff(moment(webRegisteredDate), 'days') <=  60 : false;
  }

  render() {
    const { isOpen } = this.state;
    const { userSessionLoading, userSessionLoaded } = this.props;
    return (
      <TourContainerWrapper data-test="tourcontainer">
        {isGeminiUser() && (userSessionLoaded || !userSessionLoading) &&
          <div id="secondaryNavigation">
            <SecondaryNavigationByCSR />
            <CSRSpecificDetails />
          </div>
        }
        { this.showProductTour() ?
          <TourContainer id="tourContainer" className={this.state.isTourOpen ? "accordianOpen" : "accordianClose"}
            ref={this.tourContainerRef}>
            <FixedWidth ref={node => (this.node = node)} data-test="product-tour-fix-width" className={this.state.isOpen ? "productTourContainer isOpen" : "productTourContainer isClose"} >

              <DisplayFlexContainer className="productTourOpen">
                <Col
                  xs={{ span: 24 }}
                  lg={{ span: 9, offset: 1 }}
                  className='center'
                >
                  <Img src={tourBackground} alt='take_tour_image' />
                </Col>
                <Col xs={{ span: 24 }} lg={{ span: 12 }} xl={{ span: 10 }}>
                  <HeadingComponent>
                    Welcome to our website!
                  </HeadingComponent>
                  <TextContent>
                  You’re in the right place to learn more about how to change the world through long-term, strategic charitable giving that minimizes costs and maximizes impact. Interested in learning more about the website? Click <b>Take Product Tour</b> to get a lay of the land or tap on <b>Welcome Kit</b> to read more about the most tax-effective way to consolidate, accrue, and grant your assets to charity. If there’s something you want to share with us, we want to hear it! Jump over to <b>Contact Us</b> and say hello.</TextContent>
                  <TourButtonsContainer>
                    <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                      <TourButtons id="btnTakeProduct" onClick={this.openTour}>
                        Take Product Tour
                      </TourButtons>
                      <TourButtons id="btnWelcomeKit" onClick={this.openWelcomeKit}>
                        <a href="#" >Welcome Kit</a>
                      </TourButtons> 
                    </Col>
                  </TourButtonsContainer>
                </Col>
              </DisplayFlexContainer>

              <TourTextContainer className="productTourClosed">
                Welcome to our site. Click the "Product Tour" button to see a quick preview of our website.
                </TourTextContainer>
              {
                !isGeminiUser() &&
                <TourBtn
                  id="btnOpenClose"
                  onClick={e => this.openDrawer(e)}
                  backgroundImage={tourBtn}
                  isOpen={isOpen}
                >
                  {isOpen ? 'CLOSE' : 'PRODUCT TOUR'}
                </TourBtn>
              }

              {isOpen ? this.walkThrough() : null}
            </FixedWidth>
          </TourContainer>:
          <EmptyProductTourContainer/>
        }
        </TourContainerWrapper>
    );
  }
}

ProductTour.propTypes = {
  tourHeightChanged: PropTypes.func,
  userSessionLoaded: PropTypes.any,
  userSessionLoading: PropTypes.any
}

const mapStateToProps = state => {
  return {
    accountID: selectAccountID(state.toJS()),
    userSessionLoading: sessionLoading(state.toJS()),
    ...productTourDerivedStates(state.toJS())
  };
};

export default withRouter(
  connect(
    mapStateToProps
  )(ProductTour)
);
